{
  "How to Go Live": "Cómo emitir en directo",
  "Add a room": "Añadir una sala",
  "Add a Guest": "Añadir un invitado",
  "This sign-in link has expired": "Este enlace para iniciar sesión ha caducado",
  "Couldn't sign you in from this link": "No hemos podido iniciar tu sesión con este enlace",
  "Couldn't save your profile": "No se ha podido guardar tu perfil"
}
